import { getWeekOfYear } from '../../../reducer/weekOfYearSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { getAmphurData, getAmphurDataMap, getProvinceData, getProvinceDataMap, getTambonData } from '../../../reducer/areaDataSlice';
import dotenv from 'react-dotenv';
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';
import { getIAAM } from '../../../reducer/iaamSlice';
import { getAreaLevel } from '../../../reducer/areaLevelSlice';
import { getDisease } from '../../../reducer/diseaseSlice';
import { setCompareChecked, setCompareValue, setThemeCompareSelectedValue } from '../../../reducer/patientCompareSlice';

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref,) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function PatientCompare(props) {
    const { checked } = props;
    const dispatch = useDispatch();
    const iaam = useSelector(getIAAM);
    const provinceData = useSelector(getProvinceData);
    const provinceMap = useSelector(getProvinceDataMap);
    const amphurData = useSelector(getAmphurData);
    const amphurMap = useSelector(getAmphurDataMap);
    const tambonData = useSelector(getTambonData);
    const woy = useSelector(getWeekOfYear);
    const areaLevel = useSelector(getAreaLevel);
    const disease = useSelector(getDisease);
    const [compare, setCompare] = useState('4');
    const [xvalue, setXvalue] = useState(20);

    const [areaMedian, setAreaMedian] = useState();
    const [areaPatient, setAreaPatient] = useState();
    const [themeValue, setThemeValue] = useState();
    // const [population, setPopalation] = useState(100000);

    // const handleChange = (event) => {
    //     if (!checked) {
    //         console.log(woy);
    //     }
    //     setChecked(!checked);
    // }

    useEffect(() => {
        const LoadTheme = async () => {
            // const response = await fetch(`${dotenv.WATCH_API_URL}/condition/${compare}`);
            const response = await fetch(`${dotenv.MASTER_API_URL}/visualz/get_condition/${compare}`);
            const result = await response.json();
            dispatch(setThemeCompareSelectedValue(result));
            setThemeValue(result);
            // console.log(result);
        }
        if (checked) {
            LoadTheme();
        }
    }, [compare, checked])

    useEffect(() => {
        // console.log(areaPatient);
        // console.log(areaMedian);
        // console.log(themeValue);
        if (areaPatient !== undefined && areaMedian !== undefined && themeValue !== undefined) {
            if (areaLevel === 'province') {
                setCompareDataRenderProvince();
                // setMorbidityDataRenderProvince();
            } else if (areaLevel === 'amphur') {
                setCompareDataRenderAmphur();
                // setMorbidityDataRenderAmphur();
            } else if (areaLevel === 'tambon') {
                setCompareDataRenderTambon();
                // setMorbidityDataRenderTambon();
            }
        }
    }, [provinceData, amphurData, tambonData, areaLevel, areaMedian, areaPatient, themeValue, xvalue])

    const setCompareDataRenderProvince = () => {
        // let tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        // let provAttrName = "province_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        // }
        for (let index = 0; index < provinceData.length; index++) {
            const element = provinceData[index];
            // console.log(element);
            let patientData = areaPatient[element[provAttrCode]];
            let medianData = areaMedian[element[provAttrCode]];
            if (medianData !== undefined) {
                let patient = patientData !== undefined ? patientData : 0;
                let resultCompare = checkConditionCompare(patient, medianData);

                let data = {
                    // code: element.province_code,
                    code: element[provAttrCode],
                    name: element[provAttrName],
                    // province_code: element.province_code,
                    province_code: element[provAttrCode],
                    province_name: element[provAttrName],
                    patient: patient,
                    median: medianData,
                    location: element.geojson_4326,
                    result: resultCompare.result,
                    color: resultCompare.color
                }
                // console.log(data);
                if (compare === '5') {
                    data.minus = resultCompare.minus;
                    data.plus = resultCompare.plus;
                }
                // tmp.push(data);
                tmp[element[provAttrCode]] = data;
            }
        }
        dispatch(setCompareValue(tmp));
    }

    const setCompareDataRenderAmphur = () => {
        // var tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        let ampAttrName = "amp_namt";
        let ampAttrCode = "amp_code";
        // let provAttrName = "province_name";
        // let ampAttrName = "amphur_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        //     ampAttrName = ampAttrName + "_eng";
        // }
        for (let index = 0; index < amphurData.length; index++) {
            const element = amphurData[index];
            const prov_code = element[ampAttrCode].substr(0, 2);
            let provData = provinceMap[prov_code];
            let patientData = areaPatient[element[ampAttrCode]];
            let medianData = areaMedian[element[ampAttrCode]];
            if (medianData !== undefined) {
                let patient = patientData !== undefined ? patientData : 0;
                let resultCompare = checkConditionCompare(patient, medianData);
                let data = {
                    code: element[ampAttrCode],
                    name: element[ampAttrName],
                    amphur_code: element[ampAttrCode],
                    amphur_name: element[ampAttrName],
                    province_code: provData[provAttrCode],
                    province_name: provData[provAttrName],
                    patient: patient,
                    median: medianData,
                    location: element.geojson_4326,
                    result: resultCompare.result,
                    color: resultCompare.color
                }
                if (compare === '5') {
                    data.minus = resultCompare.minus;
                    data.plus = resultCompare.plus;
                }
                // tmp.push(data);
                tmp[element[ampAttrCode]] = data;
        //         var patient = parseInt(patientData.sum);
        //         var median = medianData.median.value;
        //         var boundary = element.boundary;
        //         if (!patient) {
        //             patient = 0;
        //         }
        //         var data = {
        //             code: element.amphur_code,
        //             name: element[ampAttrName],
        //             province_code: element.province_code,
        //             province_name: element[provAttrName],
        //             patient: patient,
        //             median: median,
        //             location: boundary
        //         }
        //         var resultCompare = this.checkConditionCompare(patient, median);
        //         data.result = resultCompare.result;
        //         data.color = resultCompare.color;
        //         if (this.xValue !== undefined) {
        //             data.minus = resultCompare.minus;
        //             data.plus = resultCompare.plus;
        //         }
        //         tmp.push(data);
            }
        }
        dispatch(setCompareValue(tmp));
        // this.compareDataRender = tmp;
    }

    const setCompareDataRenderTambon = () => {
        // let tmp = new Array();
        let tmp = {};
        let provAttrName = "prov_namt";
        let provAttrCode = "prov_code";
        let ampAttrName = "amp_namt";
        let ampAttrCode = "amp_code";
        let tambonAttrName = "tambon_namt";
        let tambonAttrCode = "tambon_code";
        // let provAttrName = "province_name";
        // let ampAttrName = "amphur_name";
        // let tambonAttrName = "tambon_name";
        // if (this.language === "us" || this.language === "uk") {
        //     provAttrName = provAttrName + "_eng";
        //     ampAttrName = ampAttrName + "_eng";
        //     tambonAttrName = tambonAttrName + "_eng";
        // }
        for (let index = 0; index < tambonData.length; index++) {
            const element = tambonData[index];
            const prov_code = element[tambonAttrCode].substr(0, 2);
            const amp_code = element[tambonAttrCode].substr(0, 4);
            let provData = provinceMap[prov_code];
            let ampData = amphurMap[amp_code];
            let patientData = areaPatient[element[tambonAttrCode]];
            let medianData = areaMedian[element[tambonAttrCode]];
            if (medianData !== undefined) {
                let patient = patientData !== undefined ? patientData : 0;
                let resultCompare = checkConditionCompare(patient, medianData);
                let data = {
                    code: element[tambonAttrCode],
                    name: element[tambonAttrName],
                    tambon_code: element[tambonAttrCode],
                    tambon_name: element[tambonAttrName],
                    amphur_code: ampData[ampAttrCode],
                    amphur_name: ampData[ampAttrName],
                    province_code: provData[provAttrCode],
                    province_name: provData[provAttrName],
                    patient: patient,
                    median: medianData,
                    location: element.geojson_4326,
                    result: resultCompare.result,
                    color: resultCompare.color
                }
                if (compare === '5') {
                    data.minus = resultCompare.minus;
                    data.plus = resultCompare.plus;
                }
                // tmp.push(data);
                tmp[element[tambonAttrCode]] = data;
        //         var patient = parseInt(patientData.sum);
        //         var median = medianData.median.value;
        //         var boundary = element.boundary;
        //         if (!patient) {
        //             patient = 0;
        //         }
        //         var data = {
        //             code: element.tambon_code,
        //             name: element[tambonAttrName],
        //             amphur_code: element.amphur_code,
        //             amphur_name: element[ampAttrName],
        //             province_code: element.province_code,
        //             province_name: element[provAttrName],
        //             patient: patient,
        //             median: median,
        //             location: boundary
        //         }
        //         var resultCompare = this.checkConditionCompare(patient, median);
        //         data.result = resultCompare.result;
        //         data.color = resultCompare.color;
        //         if (this.xValue !== undefined) {
        //             data.minus = resultCompare.minus;
        //             data.plus = resultCompare.plus;
        //         }
        //         tmp.push(data);
            }
        }
        dispatch(setCompareValue(tmp));
        // this.compareDataRender = tmp;
    }

    const checkConditionCompare = (patient, median) => {
        let found_condition = false;
        let color;
        let result;
        
        if (themeValue) {
            for (let index = 0; index < themeValue.length && !found_condition; index++) {
                const element = themeValue[index];
                let operator_min = element.operator_min;
                let min_value = element.min;
                let operator_max = element.operator_max;
                let max_value = element.max;

                // console.log(`Patient : ${patient}`);
                // console.log(`Median: ${median}`);
        //         // if (patient === 0 && median === 0) {
                if (patient === 0) {
                    if (min_value === "-1" && max_value === "-1") {
                        // result = "-";
                        result = "เสี่ยงต่ำ";
                        color = element.color;
                        found_condition = true;
                    }
                } else {
        //             if (this.xValue === undefined) {
                    if (compare !== '5') {
                        if (checkValueConditionMedian(patient, operator_max, max_value, median)) {
                            // result = operator_max;
                            result = operator_max === '<' ? 'เสี่ยงต่ำ' : operator_max === "=" ? 'เสี่ยงปานกลาง' : 'เสี่ยงสูง';
                            color = element.color;
                            found_condition = true;
                        }
                    } else {
                        if (min_value === "-1" && max_value !== "-1") {
                            if (checkValueConditionMedian(patient, operator_max, max_value, median)) {
                                // result = "<";
                                result = "เสี่ยงต่ำ";
                                color = element.color;
                                found_condition = true;
                            }
                        } else if (min_value !== "-1" && max_value === "-1") {
                            if (checkValueConditionMedian(patient, operator_min, min_value, median)) {
                                // result = ">";
                                result = "เสี่ยงสูง";
                                color = element.color;
                                found_condition = true;
                            }
                        } else if (min_value !== "-1" && max_value !== "-1") {
                            if (checkValueConditionMedian(patient, operator_min, min_value, median) && checkValueConditionMedian(patient, operator_max, max_value, median)) {
                                // result = "=";
                                result = "เสี่ยงปานกลาง";
                                color = element.color;
                                found_condition = true;
                            }
                        }
                    }
                }
            }
            
        }
        let resultCompare = {
            color: color,
            result: result
        }
        if (compare === '5') {
            let minus = 1 - (xvalue / 100);
            let plus = 1 + (xvalue / 100);
            resultCompare.plus = (parseFloat(median) * plus).toFixed(2);
            resultCompare.minus = (parseFloat(median) * minus).toFixed(2);
        }
        // if (this.xValue !== undefined) {
        //     var minus = 1 - (this.xValue / 100);
        //     var plus = 1 + (this.xValue / 100);
        //     resultCompare.plus = (parseFloat(median) * plus).toFixed(2);
        //     resultCompare.minus = (parseFloat(median) * minus).toFixed(2);
        // }
        return resultCompare;
    }

    const checkValueConditionMedian = (value, operator, value_condition, median) => {
        var condition_values = getConditionValue(median, value_condition);
        if (operator === "<") {
            return value < condition_values;
        } else if (operator === "<=") {
            return value <= condition_values;
        } else if (operator === "=") {
            return value === condition_values;
        } else if (operator === ">") {
            return value > condition_values;
        } else if (operator === ">=") {
            return value >= condition_values;
        }
    }

    const getConditionValue = (median, value_condition) => {
        value_condition = value_condition.replace("median", median);
        let value = value_condition.split("*");
        if (value.length === 1) {
            return parseFloat(value[0]);
        } else {
            var x = xvalue;
            if (value[1].charAt(0) === "-") {
                x = 1 - (x / 100);
            } else if (value[1].charAt(0) === "+") {
                x = 1 + (x / 100);
            }
            return parseFloat(value[0]) * x;
        }
    }

    const callData = useCallback(() => {
        const callMedian = async () => {
            let access_token = await iaam.getAccessToken();
                
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json', 
                    'Authorization': `bearer ${access_token}`
                }
            }
            
            let tmpMedian = {};
            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/median?area_level=${areaLevel}&disease_class=${disease}&start_week=${woy?.start?.week}&start_year=${woy?.start?.year}&end_week=${woy?.end?.week}&end_year=${woy?.end?.year}&year_period=5`, options);
            const resData = await res.json();
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];
                tmpMedian[element.code] = element.median.value;
                // const total_patients = element.total_patients;
                // const area_code = element.code;
            }
            setAreaMedian(tmpMedian);
        }
        const callPatient = async () => {
            if (woy.start !== undefined) {
                let access_token = await iaam.getAccessToken();
                
                let options = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json', 
                        'Authorization': `bearer ${access_token}`
                    }
                }
                
                let tmpPatient = {};
                let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/total-patient?area_level=${areaLevel}&disease_class=${disease}&start_week=${woy?.start?.week}&start_year=${woy?.start?.year}&end_week=${woy?.end?.week}&end_year=${woy?.end?.year}`, options);
                const resData = await res.json();
                for (let index = 0; index < resData.length; index++) {
                    const element = resData[index];
                    tmpPatient[element.code] = element.total_patients;
                    // const total_patients = element.total_patients;
                    // const area_code = element.code;
                }
                setAreaPatient(tmpPatient);

                callMedian();
            }
        }
        
        // console.log(iaam);
        // console.log(areaLevel);
        // console.log(woy);
        // console.log(disease);
        // console.log(checked);
        if (areaLevel !== undefined && disease !== undefined && woy?.start !== undefined && iaam !== undefined) {
            if (checked) {
                dispatch(setCompareChecked(true))
                callPatient();
            } else {
                setAreaPatient(undefined);
                setAreaMedian(undefined);
                dispatch(setCompareValue({}));
                dispatch(setCompareChecked(false))
            }
        }
    }, [iaam, areaLevel, woy, disease, checked])

    useEffect(() => {
        callData();
    }, [callData])

    const handleXvalueChanged = (event) => {
        let xvalue = event.target.value;
        if (xvalue === "") {
            xvalue = 0;
        }
        setXvalue(xvalue);
    }

    if (checked) {
        return (
            <div style={{
                width: '100%',
                position: 'relative',
                textAlign: 'left'
            }}>
                <div style={{
                    position: 'relative',
                    marginLeft: '30px',
                    width: 'calc(100% - 30px)',
                    marginBottom: 10
                }}>
                    <div style={{
                        position: 'relative',
                    }}>
                        <FormControl fullWidth size='small' sx={{
                            marginTop: '10px'
                        }}>
                            <InputLabel id="demo-simple-select-label">การวิเคราะห์ข้อมูล</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={compare}
                                label="การวิเคราะห์ข้อมูล"
                                onChange={(event) => {
                                    setCompare(event.target.value)
                                }}
                            >
                                <MenuItem value={'4'}>มัธยฐาน 5 ปี</MenuItem>
                                <MenuItem value={'5'}>มัธยฐาน 5 ปี ± X%</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    {
                        compare === '5' ?
                            <div style={{
                                position: 'relative',
                                marginTop: 10
                            }}>
                                <TextField
                                    label="X"
                                    value={xvalue}
                                    onChange={handleXvalueChanged}
                                    name="xvalue"
                                    id="formatted-numberformat-input"
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                        endAdornment: <InputAdornment position="start">%</InputAdornment>,
                                    }}
                                    size="small"
                                    sx={{
                                        m: '8px 0px 8px 0px',
                                        position: 'relative',
                                        width: '100%'
                                    }}
                                />
                            </div> : <></>
                    }
                </div>
            </div>
        )
    } else {
        return (
            <></>
        )
    }
}

export default PatientCompare;